import { useTranslation } from 'react-i18next';
import { useCallback } from 'react';
import { LANGUAGES, RTL_LANGUAGES, type LanguageCode } from '@/i18n';

export function useLanguage() {
  const { i18n } = useTranslation();

  const currentLanguage = (i18n.language?.substring(0, 2) || 'en') as LanguageCode;
  const isRTL = RTL_LANGUAGES.has(currentLanguage);

  const changeLanguage = useCallback(async (code: LanguageCode) => {
    await i18n.changeLanguage(code);
    localStorage.setItem('ahp-language', code);

    // Update document direction and lang
    const rtl = RTL_LANGUAGES.has(code);
    document.documentElement.dir = rtl ? 'rtl' : 'ltr';
    document.documentElement.lang = code;
  }, [i18n]);

  const currentLangInfo = LANGUAGES.find(l => l.code === currentLanguage) || LANGUAGES[0];

  return {
    currentLanguage,
    currentLangInfo,
    isRTL,
    changeLanguage,
    languages: LANGUAGES,
  };
}
